<template>
    <div class="home-content">
        <van-notice-bar mode="closeable">
            请上传成员数据，方便您更好的使用哺光仪。
        </van-notice-bar>
        <AddReportComp :default-member-id="memberId" @onSuccess="handleUploadSuccess"/>
        <div class="button-skip-wrapper"><a href="javascript:void(0)" class="button-skip" @click="handleSkip">跳过</a></div>
    </div>
</template>

<script>
    import AddReportComp from "@/components/AddReportComp";
    export default {
        name: "AddReportHome",
        components: {
            AddReportComp
        },
        props: {
            memberId: String
        },
        methods: {
            handleUploadSuccess() {
                this.$router.replace("/home/index", null, () => {});
            },
            handleSkip() {
                this.$router.replace("/home/index", null, () => {});
            }
        }
    }
</script>